import "./index.css";
import { useState, useEffect } from "react";
import { Select, notification } from "antd";
import { useAuth } from "../../context/auth";

const PriceDropdown = ({ ...props }) => {
  const { accessToken } = useAuth();

  const [prices, setPrices] = useState([]);
  useEffect(() => {
    async function getPrices() {
      const url = new URL('/api/price', window.location);
      url.searchParams.append('mode', 'dropdown');

      const res = await fetch(url, {
        headers: { 'X-ACCESS-TOKEN': accessToken },
      });
      if (res.ok) {
        const { prices } = await res.json();
        setPrices(prices);
      } else {
        notification["error"]({
          message: "Something went wrong !",
          description: `Please re-login or contact web admin. (Code: ${await res.json().then(data => data.message)})`,
        });
      }
    }

    getPrices();
  }, [accessToken]);

  return (
    <Select
      {...props}
      showSearch
      placeholder="Select Price"
      optionFilterProp="children"
    >
      {prices.map(price => (
        <Select.Option key={price.id} value={price.id}>
          {price.descEn} ({price.bahtPerKwh} Baht/kWh) ({price.bahtPerHour} Baht/hr{price.calculateMethod === 'BAHT_MIN' ? `~ ${(price.bahtPerHour / 60).toFixed(3)} Baht/min` : ''})
        </Select.Option>
      ))}
    </Select>
  );
};

export default PriceDropdown;
